import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import { IPaymentsPlan } from '../../interfaces/IPaymentsPlan'
import InfoAppBar from '../../components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import { Button, Hidden, Typography } from '@mui/material'
// import SchoolFooter from '../../components/Footers/SchoolFooter2'
import dynamic from 'next/dynamic'
import LoadingSkeletonComponent from '../../components/LoadingComponents/LoadingSkeletonComponent'
import { getURLQueryParameter } from '../../services/config'
import SchoolHomePageNotificationBanner from '@/components/SchoolHomepage/DefaultHomepage/SchoolHomePageNotificationBanner'
import useUserAuthSchoolDetails from '@/components/Auhentication/useUserAuthSchoolDetails'

interface ISchoolGeneralCourseDetailsProps {
  schoolDetails: ISchool
  clusterDetails: IPaymentsPlan
  refreshStudentBillingData: () => void
}

const CourseClusterComponentLarge = dynamic(
  () =>
    import(
      '../../components/PaymentsPlan/SchoolUser/CourseClusterComponentLarge'
    ),
  {
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

const CourseClusterComponentSmall = dynamic(
  () =>
    import(
      '../../components/PaymentsPlan/SchoolUser/CourseClusterComponentSmall'
    ),
  {
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

const SchoolClusterDetails = (props: ISchoolGeneralCourseDetailsProps) => {
  const useUserAuthSchoolHook = useUserAuthSchoolDetails()

  const [userHasAccessToPage] = React.useState<boolean>(
    useUserAuthSchoolHook.checkIfUserCanViewProgramDetails({
      programId: props.clusterDetails?._id,
      schoolDetails: props.schoolDetails,
    }),
  )
  // store coupon code in session if coupon in query
  React.useEffect(() => {
    if (props.clusterDetails?._id) {
      const coupon = getURLQueryParameter('coupon')
      console.log({ coupon })
      coupon &&
        window.sessionStorage.setItem(
          `program_coupon_${props.clusterDetails._id}`,
          coupon,
        )
    }
  }, [props.clusterDetails._id])

  if (!userHasAccessToPage) {
    return (
      <div style={{ minHeight: '100vh' }}>
        <InfoAppBar school_details={props.schoolDetails} />
        <SchoolHomePageNotificationBanner schoolDetails={props.schoolDetails} />
        <div
          style={{ textAlign: 'center', maxWidth: '1000px', margin: 'auto' }}
        >
          <div>
            <img
              style={{
                marginTop: '60px',
              }}
              width="300px"
              // height="120px"
              src="/static/img/asset_empty.svg"
            />
          </div>
          <Typography
            style={{ marginTop: '50px', fontWeight: 'bold' }}
            variant={'h5'}
          >
            Ooops! Nothing to see here.
          </Typography>
          <Typography variant={'body1'} style={{ padding: '10px' }}>
            Looks like you visited the wrong link or you don't have access to
            this page
          </Typography>
          <Button variant={'contained'} href={'/'} color={'primary'}>
            Back to home
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div>
        <InfoAppBar school_details={props.schoolDetails} />
        <SchoolHomePageNotificationBanner schoolDetails={props.schoolDetails} />
        <Hidden mdDown={true}>
          <CourseClusterComponentLarge {...props} />
        </Hidden>
        <Hidden mdUp={true}>
          <CourseClusterComponentSmall {...props} />
        </Hidden>
        {/* <SchoolFooter schoolDetails={props.schoolDetails} /> */}
      </div>
    </div>
  )
}

export default SchoolClusterDetails
